import React from "react";
import {findDOMNode} from "react-dom";
import FieldMultiselect_PopoverSearch from "./popover-search";
import FieldMultiselect_PopoverOptionsSelector from "./popover-options-selector";
import VScroll from "../../../../../gd-components/scrolling/custom-v-scroll/v-scroll";
import Popover from "../../../../../gd-components/gd-popover/popover-v2";
import PopoverPosition from "../../../../../gd-components/gd-popover/popover-position";
import {FieldPopoverMenuProps} from "../../../dropdown/components/popover/popover-menu";

const SEARCH_SHOW_THRESHOLD = 6; // min options to show search input

export default class FieldMultiselect_PopoverMenu extends React.Component<FieldPopoverMenuProps,any> {

    public optionsSelector      : any
    public scroll      : any

    // static propTypes = {
    //     parent: PropTypes.object,
    //     field: PropTypes.object
    // }

    constructor(props:FieldPopoverMenuProps) {
        super(props);

        this.state = {
            searchString: null
        }
    }

    onPopoverKeyDown = (e:React.SyntheticEvent) => {if(this.optionsSelector) this.optionsSelector.onPopoverKeyDown(e)}

    onSearchChange = (newSearchString:string) => {
        this.setState({
            searchString: newSearchString
        });
    }

    updateScroll = (node:any) => {
        if (!this.scroll) return;

        const scrollNode : any = findDOMNode(this.scroll.childrenContainer);

        const nodeTop = node.offsetTop;
        const nodeBottom = node.offsetTop + node.offsetHeight;
        const scrollTop = scrollNode.scrollTop;
        const scrollBottom = scrollNode.scrollTop + scrollNode.offsetHeight;

        // ensure node to be in visible area of scroll
        if (scrollBottom < nodeBottom) this.scroll.setScrollTop(nodeBottom - scrollNode.offsetHeight, false, 100);
        else if (scrollTop > nodeTop) this.scroll.setScrollTop(nodeTop, false, 100);
    }

    render() {
        const isManager = gd.ac.check.company.isManager();

        const PopoverMenuMore = _.get(this.props.field.components, 'PopoverMenuMore', false)

        const popoverPosition = new PopoverPosition({
            attachment      : "top center",
            targetAttachment: "bottom center",
        })

        return (
            <Popover
                className           = {this.props.field.classes.PopoverContent}
                position            = {popoverPosition}
                getTargetFunc       = {()=>findDOMNode(this.props.parent)}
                onKeyDown           = {this.onPopoverKeyDown}
                onClickOutside      = {()=>{this.props.parent.hidePopover()}}
            >
                <FieldMultiselect_PopoverSearch searchable={this.props.field.isSearchable && this.props.field.getOptions()!.length > SEARCH_SHOW_THRESHOLD}
                                                searchString={this.state.searchString}
                                                onHidePopover={this.props.parent.hidePopover}
                                                onSearchChange={this.onSearchChange}/>

                <div className={Classes("ui5-popover-menu", this.props.field.classes.PopoverMenu, {'with-help': isManager && PopoverMenuMore})}>
                    <VScroll minDragHeight={20} containerClass={this.props.field.classes.PopoverMenuScrollContainer} scrollVisibility="auto">
                        <FieldMultiselect_PopoverOptionsSelector ref={(r:any)=>this.optionsSelector = r}
                                                                 {...this.props}
                                                                 searchString={this.state.searchString}
                                                                 onUpdateScroll={this.updateScroll}/>
                    </VScroll>

                    {isManager && PopoverMenuMore && <PopoverMenuMore {...this.props}/>}
                </div>
            </Popover>
        );
    }
}
